exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiLayoutDetail/ubiLayoutDetail.component.scss
// module id = ../../../../../src/app/theme/components/ubiLayoutDetail/ubiLayoutDetail.component.scss
// module chunks = main